import { render, staticRenderFns } from "./CmgCelebratePoints.vue?vue&type=template&id=f096fa4c&scoped=true&lang=pug&"
import script from "./cmg-celebrate-points.ts?vue&type=script&lang=ts&"
export * from "./cmg-celebrate-points.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCelebratePoints.vue?vue&type=style&index=0&id=f096fa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f096fa4c",
  null
  
)

export default component.exports